// Venue POS receipt maths. Sale amounts are VAT-inclusive, so the net and VAT
// figures are derived from the gross total the customer actually paid.

const VAT_RATE = 0.2;

export const POS_COMPANY_FOOTER =
  'Motion Reality Sim Racing Ltd · Co No: 16171282 · VAT No: GB 491 158 870';

export function money(n) {
  return `£${(Number(n) || 0).toFixed(2)}`;
}

export function netFromGross(gross) {
  return (Number(gross) || 0) / (1 + VAT_RATE);
}

/**
 * Build the receipt lines and totals for a POS sale.
 * Every line carries its own net figure so the card foots exactly.
 */
export function buildReceipt({ experienceName, experiencePrice, addons = [], amount }) {
  const lines = [];

  if (experienceName) {
    lines.push({ label: experienceName, qty: 1, gross: Number(experiencePrice) || 0 });
  }
  for (const a of addons) {
    const gross = (Number(a.price) || 0) * (Number(a.qty) || 0);
    lines.push({ label: a.name, qty: Number(a.qty) || 0, gross });
  }

  const grossTotal = Number(amount) || lines.reduce((s, l) => s + l.gross, 0);
  const netTotal = netFromGross(grossTotal);

  return {
    lines: lines.map((l) => ({ ...l, net: netFromGross(l.gross) })),
    netTotal,
    vatTotal: grossTotal - netTotal,
    grossTotal,
    vatRatePct: VAT_RATE * 100,
  };
}